import { render } from "./CampaignShare.vue?vue&type=template&id=6571a42f&scoped=true"
import script from "./CampaignShare.vue?vue&type=script&lang=js"
export * from "./CampaignShare.vue?vue&type=script&lang=js"

import "./CampaignShare.vue?vue&type=style&index=0&id=6571a42f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6571a42f"]])

export default __exports__